import { Injectable } from '@angular/core';

export class OpenIDImplicitFlowConfiguration {
  stsServer: string;
  redirect_url: string;
  client_id: string;
  response_type: string;
  resource: string;
  scope: string;
  hd_param: string;
  post_logout_redirect_uri: string;
  start_checksession: boolean;
  silent_renew: boolean;
  silent_renew_offset_in_seconds: number;
  silent_renew_url: string;
  post_login_route: string;
  forbidden_route: string;
  unauthorized_route: string;
  auto_userinfo: boolean;
  auto_clean_state_after_authentication: boolean;
  trigger_authorization_result_event: boolean;
  log_console_warning_active: boolean;
  log_console_debug_active: boolean;
  max_id_token_iat_offset_allowed_in_seconds: number;
  storage: any;
}

@Injectable()
export class AuthConfiguration {
  private openIDImplicitFlowConfiguration: OpenIDImplicitFlowConfiguration;

  get stsServer(): string {
    return this.openIDImplicitFlowConfiguration.stsServer;
  }

  get redirect_url(): string {
    return this.openIDImplicitFlowConfiguration.redirect_url;
  }

  get silent_redirect_url(): string {
    return this.openIDImplicitFlowConfiguration.silent_renew_url;
  }

  get client_id(): string {
    return this.openIDImplicitFlowConfiguration.client_id;
  }

  get response_type(): string {
    return this.openIDImplicitFlowConfiguration.response_type;
  }

  get resource(): string {
    return this.openIDImplicitFlowConfiguration.resource;
  }

  get scope(): string {
    return this.openIDImplicitFlowConfiguration.scope;
  }

  get hd_param(): string {
    return this.openIDImplicitFlowConfiguration.hd_param;
  }

  get post_logout_redirect_uri(): string {
    return this.openIDImplicitFlowConfiguration.post_logout_redirect_uri;
  }

  get start_checksession(): boolean {
    return this.openIDImplicitFlowConfiguration.start_checksession;
  }

  get silent_renew(): boolean {
    return this.openIDImplicitFlowConfiguration.silent_renew;
  }

  get silent_renew_offset_in_seconds(): number {
    return this.openIDImplicitFlowConfiguration.silent_renew_offset_in_seconds;
  }

  get post_login_route(): string {
    return this.openIDImplicitFlowConfiguration.post_login_route;
  }

  get forbidden_route(): string {
    return this.openIDImplicitFlowConfiguration.forbidden_route;
  }

  get unauthorized_route(): string {
    return this.openIDImplicitFlowConfiguration.unauthorized_route;
  }

  get auto_userinfo(): boolean {
    return this.openIDImplicitFlowConfiguration.auto_userinfo;
  }

  get auto_clean_state_after_authentication(): boolean {
    return this.openIDImplicitFlowConfiguration.auto_clean_state_after_authentication;
  }

  get trigger_authorization_result_event(): boolean {
    return this.openIDImplicitFlowConfiguration.trigger_authorization_result_event;
  }

  get log_console_warning_active(): boolean {
    return this.openIDImplicitFlowConfiguration.log_console_warning_active;
  }

  get log_console_debug_active(): boolean {
    return this.openIDImplicitFlowConfiguration.log_console_debug_active;
  }

  get max_id_token_iat_offset_allowed_in_seconds(): number {
    return this.openIDImplicitFlowConfiguration.max_id_token_iat_offset_allowed_in_seconds;
  }

  get storage(): any {
    return this.openIDImplicitFlowConfiguration.storage;
  }

  constructor() {}

  init(openIDImplicitFlowConfiguration: OpenIDImplicitFlowConfiguration) {
    this.openIDImplicitFlowConfiguration = openIDImplicitFlowConfiguration;
  }
}
